import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Grid, Label, Segment } from 'semantic-ui-react'
import { compose } from 'recompose'

import Container from './SearchModuleContainer'
import Enhancer from './SearchModuleEnhancer'
import StandardError from 'Components/StandardError'
import StandardLoader from 'Components/StandardLoader'
import { withPermissions } from 'Components/Permissions'

import ErrorMassive from 'Components/ErrorMassive'
import LayoutButtonGroup from 'Components/LayoutButtonGroup'
import LayoutManager from 'Components/LayoutManager'
import MySearchesSaveModal from 'Components/MySearchesSaveModal'
import PageHeaderRow from 'Components/PageHeaderRow'
import Pagination from 'Components/Pagination'
import PreviewModal from 'Components/PreviewModal'
import SearchForm from 'Components/SearchForm'

import * as styles from './styles'
import { THEME_COLOR } from 'Global/constants'

class SearchModule extends Component {
  static propTypes = {
    dones: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    handleExportToExcel: PropTypes.func.isRequired,
    handleSaveSearch: PropTypes.func.isRequired,
    handleSort: PropTypes.func.isRequired,
    layout: PropTypes.string.isRequired,
    limit: PropTypes.number.isRequired,
    location: PropTypes.object.isRequired,
    mySearchesSaveModalOpen: PropTypes.bool.isRequired,
    pagination: PropTypes.object.isRequired,
    pendings: PropTypes.object.isRequired,
    previewOpen: PropTypes.bool.isRequired,
    removeQueryFromUrl: PropTypes.func.isRequired,
    rugs: PropTypes.array.isRequired,
    setPage: PropTypes.func.isRequired,
    searchForm: PropTypes.bool.isRequired,
    sortBy: PropTypes.string.isRequired,
    sortOrder: PropTypes.string.isRequired,
    toggleLayout: PropTypes.func.isRequired,
    toggleLimit: PropTypes.func.isRequired,
    toggleMySearchesSaveModal: PropTypes.func.isRequired,
    togglePreview: PropTypes.func.isRequired,
    toggleSearchForm: PropTypes.func.isRequired,
    toggleSortOrder: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
  }

  render() {
    const {
      dones,
      errors,
      handleExportToExcel,
      handleSaveSearch,
      handleSort,
      layout,
      limit,
      mySearchesSaveModalOpen,
      pagination,
      pendings,
      previewOpen,
      removeQueryFromUrl,
      rugs,
      setPage,
      searchForm,
      sortBy,
      sortOrder,
      toggleLayout,
      toggleLimit,
      toggleMySearchesSaveModal,
      togglePreview,
      toggleSearchForm,
      toggleSortOrder,
      user,
    } = this.props

    const { params } = this.props.location.query

    return (
      rugs && (
        <Grid>
          <Grid.Row columns={searchForm ? 2 : 1}>
            {searchForm && (
              <Grid.Column width={5}>
                <div style={styles.header}>
                  <PageHeaderRow title="Search" />
                </div>
                <div style={styles.form}>
                  <Grid.Row>
                    <SearchForm
                      params={params ? JSON.parse(params) : {}}
                      removeQueryFromUrl={removeQueryFromUrl}
                      toggleMySearchesSaveModal={toggleMySearchesSaveModal}
                    />
                  </Grid.Row>

                  <br />

                  <Grid.Row>
                    <Pagination
                      itemName="rug"
                      items={pagination.totalRugs}
                      page={pagination.page}
                      pages={pagination.pages}
                      setPage={setPage}
                    />
                  </Grid.Row>
                </div>
              </Grid.Column>
            )}

            <Grid.Column width={searchForm ? 11 : 16}>
              <Segment style={styles.rugCardsSegment}>
                <Label
                  as="a"
                  color={THEME_COLOR}
                  corner="left"
                  icon={searchForm ? 'expand arrows alternate' : 'compress'}
                  onClick={toggleSearchForm}
                />

                <LayoutButtonGroup
                  exportToExcel={handleExportToExcel}
                  layout={layout}
                  handleSort={handleSort}
                  limit={limit}
                  sortBy={sortBy}
                  sortOrder={sortOrder}
                  toggleLayout={toggleLayout}
                  toggleLimit={toggleLimit}
                />

                <LayoutManager
                  handleSort={handleSort}
                  layout={layout}
                  rugs={rugs}
                  searchForm={searchForm}
                  sortBy={sortBy}
                  sortOrder={sortOrder}
                  togglePreview={togglePreview}
                  toggleSortOrder={toggleSortOrder}
                  user={user}
                />

                {!searchForm && rugs.length > 0 && (
                  <div>
                    <br />

                    <Pagination
                      itemName="rug"
                      items={pagination.totalRugs}
                      page={pagination.page}
                      pages={pagination.pages}
                      setPage={setPage}
                    />
                  </div>
                )}

                <ErrorMassive enabled={rugs.length === 0} message="No rugs found." />
              </Segment>

              {mySearchesSaveModalOpen && (
                <MySearchesSaveModal
                  done={dones.saveSearch}
                  error={errors.saveSearch}
                  handleSaveSearch={handleSaveSearch}
                  open={mySearchesSaveModalOpen}
                  pending={pendings.saveSearch}
                  toggle={toggleMySearchesSaveModal}
                />
              )}

              {previewOpen && <PreviewModal open={previewOpen} rugs={rugs} toggle={togglePreview} />}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      )
    )
  }
}

const composed = compose(
  withPermissions('modules.search'),
  Enhancer,
  StandardLoader('Bringing in the rugs…'),
  StandardError,
  Container,
)

export default composed(SearchModule)
